export enum PaymentMethod {
  INVOICE_PAYMENT = "INVOICE_PAYMENT",
  OFFLINE_PAYMENT = "OFFLINE_PAYMENT",
  BOTH = "BOTH",
  NONE = "NONE"
}
